export const usePurchase = () => {
  const {
    $api,
    $dialogs,
    $i18n,
    $auth,
    $subscription,
    $t,
    $customGtm,
    $login,
  } = useNuxtApp();

  async function purchase(item: any) {
    if (isLoggedIn()) {
      $dialogs.loader = true;
      const { consume, purchase } = await getArticlePurchaseResponse(
        item.id,
        true,
        item.contentType,
      );

      if (consume?.length) {
        // TODO get credit price from article
        const subGroups = consume;
        $dialogs.loader = false;
        const consumeGroups = subGroups.map((el: any) => {
          return {
            ...el,
            consumable: true,
          };
        });
        $dialogs.openPurchasePop(item, consumeGroups);
      } else {
        try {
          $dialogs.loader = false;
          const subGroups = purchase;
          const isDTO = subGroups.find((e: any) => {
            if (e.type === 'DTO') {
              e.title = $t('DTO.name');
            }
            return e.type === 'DTO';
          });
          const subGroupsSubType = subGroups.find(
            (e: any) => e.subscriptionType,
          );
          if (isDTO && !subGroupsSubType) {
            $dialogs.openPurchasePop(item, subGroups);
          } else if (subGroupsSubType || (isDTO && subGroupsSubType)) {
            subGroups.forEach((v: any) => {
              const sort = v?.subscriptionType?.attributes?.find(
                (category: any) => {
                  return category.key === ('ment_sort' as String);
                },
              );
              v.sort = sort ? +sort.value : 30;
            });
            const sortedSubGroups = subGroups?.sort((a: any, b: any) => {
              return a.sort - b.sort;
            });

            $dialogs.openPurchasePop(item, sortedSubGroups);
          }
        } catch (error) {
          // console.info(error);
          $dialogs.loader = false;
        }
      }
    } else {
      // need login
      $dialogs.openLoginDialog(item.id, 'music');
    }
  }
  async function checkIfCanConsume(
    item: any,
    itemId: number,
    redirect?: string,
    referralSource?: string,
  ) {
    if (!$dialogs.loader) {
      $dialogs.loader = true;
    }
    if (isLoggedIn() || $api.tenant?.default.subDirectFlow) {
      const {
        consume,
        unavailable,
        purchase,
        upgradeTo,
        downgradeTo,
        data,
        error,
      } =
        (await getArticlePurchaseResponse(
          itemId,
          false,
          item.firstEpisodeContentType || item.contentType,
          item.providerId,
          referralSource,
        )) || {};

      if (data?.url) {
        return data;
      }
      if (error?.response?.status === '404 Not Found') {
        $dialogs.loader = false;
        $dialogs.deviceNotSupported = true;
        return false;
      }
      if (consume?.length > 0) {
        return true;
      } else if (unavailable?.find((item: any) => item.articleSubscription)) {
        unavailableHandling();
      } else {
        purchaseHandling(purchase, redirect, item);
        if (upgradeTo && upgradeTo.length) {
          upgradeHandling(upgradeTo, redirect, item);
        } else if (downgradeTo && downgradeTo.length) {
          upgradeHandling(downgradeTo, redirect, item);
        } else {
          purchaseHandling(purchase, redirect, item);
        }
        // Tracking
        if (item) {
          $customGtm?.track({
            ET: 'Event',
            EA: item.title ? item.title : item.data.title,
            EC: 'Pop up Subscription Option',
          });
        }
      }
    } else {
      // need login
      $dialogs.loader = false;
      $dialogs.openLoginDialog(itemId, item?.contentType || '', redirect);
    }
    $dialogs.loader = false;
  }
  function isLoggedIn() {
    return $auth.isLoggedIn;
  }
  async function getArticlePurchaseResponse(
    itemId: number | string,
    isDto?: boolean,
    contentType?: string,
    externalProviderCode?: number | string,
    referralSource?: string,
  ) {
    try {
      const purchaseResponse = await $api.endPoints.getArticlePurchaseOptions(
        itemId,
        isDto,
        contentType,
        externalProviderCode,
        referralSource,
      );
      return purchaseResponse?.data;
    } catch (err: any) {
      $dialogs.loader = false;
      // console.info(err, 'failed to fetch getArticlePurchaseOptions');
      return err?.data;
    }
  }
  function purchaseHandling(
    purchase: unknown[],
    redirect?: string,
    item?: Object,
  ) {
    // need subscription
    try {
      const priceOptions = purchase.map((e: any) => e.purchaseIdentifier);
      const subGroups: any = $subscription.getClubs(
        JSON.stringify(priceOptions),
      );
      // sort the subscription group of group
      if (subGroups?.[0] && Array.isArray(subGroups[0])) {
        subGroups?.forEach((group) => {
          let defaultSub = $subscription.getDefaultSubscription(group);
          const sortCategory = defaultSub?.attributes?.find((category: any) => {
            return category.key === ('ment_sort_category' as String);
          });
          group[0].sortCategory = sortCategory ? +sortCategory.value : 30;
        });
        subGroups.sort((a, b) => {
          return a?.[0]?.sortCategory > b?.[0]?.sortCategory ? 1 : -1;
        });
      }
      // TODO add logic if more than one group returned
      $dialogs.loader = false;
      if (priceOptions.length) {
        $dialogs.openSubscribeDecideDialog(subGroups, '', redirect, item);
      }
    } catch (error) {
      $dialogs.loader = false;
      // console.info(error);
    }
  }
  function upgradeHandling(
    upgradeTo: unknown[],
    redirect?: string,
    item?: Object,
  ) {
    // need subscription
    try {
      const priceOptions = upgradeTo.map((e: any) => e.toSubscriptionType);
      const subGroups = $subscription.getClubs(JSON.stringify(priceOptions));
      sessionStorage.setItem('upgradeTo', JSON.stringify(upgradeTo));
      // TODO add logic if more than one group returned
      $dialogs.loader = false;
      if (priceOptions.length) {
        $dialogs.openSubscribeDecideDialog(subGroups, '', redirect, item);
      }
    } catch (error) {
      $dialogs.loader = false;
      // console.info(error);
    }
  }
  function unavailableHandling() {
    $dialogs.loader = false;
    $dialogs.openInActiveSubscriptionDialog();
  }

  return {
    purchase,
    checkIfCanConsume,
    isLoggedIn,
    getArticlePurchaseResponse,
    purchaseHandling,
    unavailableHandling,
  };
};
